import { Modal, Form, Input, Select, message } from "antd";
import { useCreateExpenseUnit } from "@/pages/Expenses/ManageExpense/hooks/useExpenseUnits";
import { useEffect } from "react";
import { UNIT_TYPE_OPTIONS } from "@/constants/expenseUnit";
import { CreateExpenseUnitFormValues } from "@/pages/Expenses/ManageExpense/api/expenseUnits";

interface CreateModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
}

const CreateModal = ({ isOpen, onClose, onSuccess }: CreateModalProps) => {
  const [form] = Form.useForm();
  const { mutate: createExpenseUnit, isPending } = useCreateExpenseUnit();

  const handleSubmit = async (values: CreateExpenseUnitFormValues) => {
    createExpenseUnit(values, {
      onSuccess: () => {
        message.success("Successfully created expense unit");
        form.resetFields();
        onClose?.();
        onSuccess?.();
      },
    });
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields();
    }
  }, [isOpen, form]);

  return (
    <Modal
      title="New Unit"
      open={isOpen}
      onCancel={handleCancel}
      width={600}
      confirmLoading={isPending}
      onOk={form.submit}
      okText="Create"
      destroyOnHidden
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="symbol" label="Symbol" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="unit_type"
          label="Unit Type"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Select unit type"
            options={UNIT_TYPE_OPTIONS.map((option) => ({
              label: option.label,
              value: option.value,
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateModal;
